module.exports = "/images/vendor/flag-icon-css/flags/4x3/kg.svg?1cfa1c79dd521076fb17f8d024e3d19f";